<template>
  <svg
    width="216"
    height="162"
    viewBox="0 0 216 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M123.229 102.237C112.962 97.1895 97.8503 94 81 94C56.8024 94 36.1894 100.577 28.3639 109.788C10.7495 114.059 0 119.75 0 126C0 139.255 48.3532 150 108 150C167.647 150 216 139.255 216 126C216 113.894 175.664 103.881 123.229 102.237Z"
      fill="#E7E8E9"
    />
    <path
      d="M156.753 39.7579L75.9397 69.1717C75.4207 69.3606 75.1531 69.9344 75.342 70.4534L92.443 117.438C92.6319 117.957 93.2058 118.225 93.7247 118.036L174.538 88.622C175.057 88.4331 175.325 87.8592 175.136 87.3403L158.035 40.3556C157.846 39.8366 157.272 39.5691 156.753 39.7579Z"
      fill="#97D3C6"
    />
    <path
      d="M75 69.5137L126.404 83.7957C126.815 83.91 127.254 83.7503 127.496 83.3982L157.693 39.4159L175.136 87.3402C175.325 87.8592 175.057 88.433 174.538 88.6219L93.7247 118.036C93.2058 118.225 92.6319 117.957 92.443 117.438L75 69.5137Z"
      fill="#97D3C6"
    />
    <path
      d="M75 69.5137L92.443 117.438C92.6319 117.957 93.2058 118.225 93.7247 118.036L174.538 88.6219C175.057 88.433 175.325 87.8592 175.136 87.3402L157.693 39.4159M75 69.5137L126.404 83.7957C126.815 83.91 127.254 83.7503 127.496 83.3982L157.693 39.4159M75 69.5137C141.154 45.4355 154.163 40.7005 157.693 39.4159"
      stroke="#BBE2DA"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M173.554 38.035C170.532 29.7314 161.351 25.45 153.047 28.4723C144.743 31.4946 140.462 40.676 143.484 48.9797C146.507 57.2833 155.688 61.5647 163.992 58.5425C172.295 55.5202 176.577 46.3387 173.554 38.035Z"
      fill="#53B7A1"
    />
    <path
      d="M161.007 50.3459C159.908 50.7459 158.864 50.8111 157.874 50.5416C156.887 50.266 155.99 49.6779 155.183 48.7772C154.38 47.8705 153.707 46.6719 153.164 45.1814C152.626 43.6892 152.376 42.3443 152.414 41.1465C152.454 39.9426 152.766 38.9223 153.348 38.0855C153.935 37.2472 154.775 36.6288 155.87 36.2305C156.964 35.8321 158.006 35.7654 158.994 36.0305C159.982 36.2956 160.877 36.877 161.677 37.7748C162.482 38.671 163.155 39.8622 163.696 41.3482C164.24 42.8432 164.493 44.1971 164.456 45.4098C164.422 46.6165 164.112 47.6413 163.527 48.4841C162.946 49.3253 162.106 49.9459 161.007 50.3459ZM160.247 48.2569C161.101 47.946 161.622 47.2802 161.81 46.2595C162.001 45.2328 161.797 43.8985 161.2 42.2567C160.805 41.1711 160.359 40.3003 159.863 39.6443C159.368 38.9883 158.845 38.5487 158.295 38.3256C157.744 38.098 157.185 38.087 156.62 38.2927C155.77 38.602 155.252 39.2692 155.066 40.2943C154.878 41.315 155.079 42.6404 155.667 44.2705C156.059 45.3622 156.502 46.239 156.995 46.9011C157.492 47.5615 158.017 48.0056 158.568 48.2331C159.118 48.4563 159.677 48.4642 160.247 48.2569Z"
      fill="white"
    />
    <path
      d="M67.0009 23.2526L36.2209 57.4372C35.8514 57.8477 35.8845 58.48 36.2949 58.8495L55.6167 76.2469C56.0271 76.6165 56.6594 76.5833 57.029 76.1729L87.809 41.9882C88.1785 41.5778 88.1454 40.9455 87.735 40.576L68.4132 23.1786C68.0028 22.809 67.3705 22.8422 67.0009 23.2526Z"
      fill="#97D3C6"
    />
    <path
      d="M35.5518 58.1804L63.4951 51.8208C63.9073 51.727 64.2159 51.3842 64.2661 50.9645L67.67 22.5095L87.7349 40.576C88.1454 40.9455 88.1785 41.5778 87.8089 41.9883L57.0289 76.1729C56.6594 76.5834 56.0271 76.6165 55.6167 76.2469L35.5518 58.1804Z"
      fill="#97D3C6"
    />
    <path
      d="M35.5518 58.1804L55.6167 76.2469C56.0271 76.6165 56.6594 76.5834 57.0289 76.1729L87.8089 41.9883C88.1785 41.5778 88.1454 40.9455 87.7349 40.576L67.67 22.5095M35.5518 58.1804L63.4951 51.8208C63.9073 51.727 64.2159 51.3842 64.2661 50.9645L67.67 22.5095M35.5518 58.1804C61.2464 29.6437 66.2991 24.032 67.67 22.5095"
      stroke="#BBE2DA"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>
